import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Layout from '@/layout'
import FairLayout from '@/layout/fair'
import CvEdit from '@/layout/cv/cv_edit'
import CvView from '@/layout/cv/cv_view'
import store from '../store'
import Fair from '../layout/fair.vue'
import MapLayout from '../layout/map.vue'

Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      meta:{
        label:'Hiturn智聘'
      },
      component: Layout,
      redirect:'/home',
      children:[
        {
          path:'index',
          meta:{
            label:function(){
              if (store.getters.userType=='enterprise') {
                  return '人才搜索'
              }else{
                return '我的求职'
              }
            }
          },
          component: () => {

            if (store.getters.userType=='enterprise') {
              return import('@/views/cv/index')
            }else{
              return import('@/views/job/apply/my_apply_list')
            }
          },
        },{
          path:'home',
          meta:{
            label:'首页'
          },
          component: () => {
            if (store.getters.userType=='enterprise') {
              return import('@/views/home')
            }else{
              return import('@/views/home_personal')
            }
          },
        },
        {
          path:'enterpriseInfo',
          meta:{
            label:'企业信息补充'
          },
          component: () => import('@/views/enterprise/enterprise_info_view')
        },
        {
          path:'submitSuccess',
          meta:{
            label:'消息提示'
          },
          component: () => import('@/views/submitSuccess')
        },
        {
          path:'hrSuccess',
          meta:{
            label:'消息提示'
          },
          component: () => import('@/views/hrSuccess')
        },
        {
          path:'examSuccess',
          meta:{
            label:'消息提示'
          },
          component: () => import('@/views/examSuccess'),
        },
        {
          path:'paySuccess',
          meta:{
            label:'消息提示'
          },
          component: () => import('@/views/paySuccess'),
        }
      ]
    },
    {
      path:'/hr',
      component:Layout,
      name:'Hr',
      meta:{
        label:'HR之家'
      },
      redirect:'/hr/hr_index',
      children:[{
        path: 'apply_hr',
        meta: {
          label: 'HR身份认证'
        },
        component: () => import('@/views/hr/apply_hr')
      },{
        path: 'hr_index',
        meta: {
          label: 'HR之家'
        },
        component: () => import('@/views/hr/hr_index')
      }
      ]

    },
    {
      path:'/log',
      name: 'Log',
      component: Layout,
      meta:{
        label:'系统日志'
      },
      children:[
        {
          path:'log_list_view',
          meta:{
            label:'系统事件'
          },
          component: () => import('@/views/log/log_list_view'),
        }
      ]
    },
    {
      path:'/cv',
      name: 'CV',
      meta:{
        label:function(){
          if (store.getters.userType=='enterprise') {
            return 'Hiturn智聘'
          }else{
            return '用户简历'
          }
        }
      },
      component: Layout,
      redirect:'/cv/my_cv',
      children:[
        {
          path:'my_cv',
          meta:{
            label:'我的简历'
          },
          component: () => import('@/views/cv/my_cv'),
        },
        {
          path:'no_permission',
          meta: {
            label:'评估报告_没有权限'
          },
          component: () => import('@/views/cv/no_permission'),
        },
        {
          path:'cv_no_finish',
          meta: {
            label:'简历未完善'
          },
          component: () => import('@/views/cv/cv_no_finish'),
        },
        {
          path:'cv_search',
          meta:{
            label:'简历查找'
          },
          component: () => import('@/views/cv/index'),
        },
        {
          path:'cv_manager',
          meta:{
            label:'简历管理'
          },
          component: () => import('@/views/cv/cv_manager'),
        },
        {
          path:'cv_preview',
          meta:{
            label:'简历管理'
          },
          component: () => import('@/views/cv/cv_preview'),
        },
        {
          path:'cv_collection',
          meta:{
            label:'简历收藏'
          },
          component: () => import('@/views/cv/cv_collection'),
        },
        {
          path:'cv_download',
          meta:{
            label:'下载的简历'
          },
          component: () => import('@/views/cv/cv_download'),
        },
        {
          path:'cv_big_query/:id',
          meta: {
            label:'简历大数据'
          },
          component: () => import('@/views/cv/index_bigdata'),
        },
        {
          path:'cv_download_success',
          meta:{
            label:'简历下载成功'
          },
          component: () => import('@/views/cv/cv_download_success'),
        },
        {
          path:'cv_edit',
          component: CvEdit,
          redirect:'/cv/cv_edit/base_info_view',
          meta: {
            keepAlive: false, // 此组件不需要被缓存
            label:'简历编辑'
          },
          children:[
            {
              path:'base_info_view',
              meta: {
                label:'基本信息'
              },
              component: () => import('@/views/cv/view/base_info_view'),
            },
            {
              path:'work_required_view',
              meta: {
                label:'求职意向'
              },
              component: () => import('@/views/cv/view/work_required_view'),
            },
            {
              path:'work_experience_view',
              meta: {
                label:'工作经验'
              },
              component: () => import('@/views/cv/view/work_experience_view'),
            },
            {
              path:'edu_experience_view',
              meta: {
                label:'教育经历'
              },
              component: () => import('@/views/cv/view/edu_experience_view'),
            },
            {
              path:'language_ability_view',
              meta: {
                label:'语言能力'
              },
              component: () => import('@/views/cv/view/language_ability_view'),
            },
            {
              path:'train_experience_view',
              meta: {
                label:'培训经历'
              },
              component: () => import('@/views/cv/view/train_experience_view'),
            },
            {
              path:'ext_skill_view',
              meta: {
                label:'专业技能'
              },
              component: () => import('@/views/cv/view/ext_skill_view'),
            },
            {
              path:'base_info_edit',
              meta: {
                label:'基本信息'
              },
              component: () => import('@/views/cv/edit/base_info_edit'),
            },
            {
              path:'work_required_edit',
              meta: {
                label:'求职意向'
              },
              component: () => import('@/views/cv/edit/work_required_edit'),
            },
            {
              path:'work_experience_edit',
              meta: {
                label:'工作经验'
              },
              component: () => import('@/views/cv/edit/work_experience_edit'),
            },
            {
              path:'edu_experience_edit',
              meta: {
                label:'教育经历'
              },
              component: () => import('@/views/cv/edit/edu_experience_edit'),
            },
            {
              path:'language_ability_edit',
              meta: {
                label:'语言能力'
              },
              component: () => import('@/views/cv/edit/language_ability_edit'),
            },
            {
              path:'train_experience_edit',
              meta: {
                label:'培训经历'
              },
              component: () => import('@/views/cv/edit/train_experience_edit'),
            },
            {
              path:'ext_skill_edit',
              meta: {
                label:'专业技能'
              },
              component: () => import('@/views/cv/edit/ext_skill_edit'),
            }
          ]
        },
        {
          path:'cv_view',
          component: CvView,
          redirect:'/cv/cv_view/cv_view',
          meta:{
            label:function(){
              if (store.getters.userType=='enterprise') {
                return '人才搜索'
              }else{
                return '简历信息'
              }
            }
          },
          children:[
            {
              path:'cv_view',
              meta: {
                label:function(){
                  if (store.getters.userType=='enterprise') {
                    return '简历预览'
                  }else{
                    return '简历详情'
                  }
                }
              },
              component: () => import('@/views/cv/cv_view'),
            },
            {
              path:'cv_view_ent',
              meta: {
                label:'简历预览'
              },
              component: () => import('@/views/cv/cv_view_by_enterprise'),
            }
            ]
        },
        {
          path:'personal_profile',
          meta: {
            label:'个人信息总览'
          },
          component: () => import('@/views/cv/personal_profile'),
        }
      ]

    },
    {
      path:'/job',
      name:'Job',
      meta: {
        label:'职位大厅'
      },
      redirect:function(){
        if (store.getters.userType=='enterprise') {
          return '/job/job_list'
        }else{
          return '/job/job_list_view'
        }
      },
      component:Layout,
      children:[
        {
          path:'job_list',
          meta: {
            label:'职位列表'
          },
          component: () => import('@/views/job/job_list'),
        },

        {
          path:'job_mine_sd',
          meta: {
            label:'查看与下载'
          },
          component: () => import('@/views/job/job_mine_sd'),
        },
        {
          path:'job_pub',
          meta: {
            label:'职位发布'
          },
          component: () => import('@/views/job/job_publish'),
        },
        {
          path:'job_pub_old',
          meta: {
            label:'职位发布'
          },
          component: () => import('@/views/job/job_publish_old'),
        },
        {
          path:'job_detail/:id/:apply',
          meta: {
            label:'职位申请'
          },
          component: () => import('@/views/job/job_detail'),
        },
        {
          path:'job_modify/:id',
          meta: {
            label:'职位修改'
          },
          component: () => import('@/views/job/job_modify'),
        },
        {
          path:'job_copy/:id',
          meta: {
            label:'职位复制'
          },
          component: () => import('@/views/job/job_copy'),
        },
        {
          path:'job_list_view',
          meta: {
            label:'职位搜索'
          },
          component: () => import('@/views/job/job_list_view'),
        },
        {
          path:'job_manager',
          meta: {
            label:'职位管理'
          },
          component: () => import('@/views/job/job_manager'),
        },
        {
          path:'/job/job_list_manager/:state',
          meta: {
            label:'职位管理列表'
          },
          component: () => import('@/views/job/job_list_manager'),
        },
        {
          path:'/job/job_list_manager_apply/:state',
          meta: {
            label:'职位投递信息列表'
          },
          component: () => import('@/views/job/job_list_manager_apply'),
        },
        {
          path:'job_new_apply_list',
          meta: {
            label:'职位申请列表'
          },
          component: () => import('@/views/job/apply/new_apply_cv'),
        },
        {
          path:'job_apply_list/:jobId/:state',
          meta: {
            label:'职位申请列表'
          },
          component: () => import('@/views/job/apply/new_apply_cv'),
        },
        {
          path:'my_apply_list',
          meta: {
            label:'求职管理'
          },
          component: () => import('@/views/job/apply/my_apply_list'),
        },
        {
          path:'my_interview_list',
          meta: {
            label:'我的邀约'
          },
          component: () => import('@/views/job/apply/my_interview_list'),
        },
        {
          path:'pub_job_success',
          meta: {
            label:'职位发布成功'
          },
          component: () => import('@/views/job/job_success'),
        },
        {
          path:'apply_success',
          meta: {
            label:'职位申请成功'
          },
          component: () => import('@/views/job/job_apply_success'),
        },
        {
          path:'my_fair_list',
          meta: {
            label:'我报名的招聘会'
          },
          component: () => import('@/views/fair/my_fair_list'),
        }

      ]
    },
    {
      path:'/enterprise',
      name:'Enterprise',
      meta: {
        label:'企业信息'
      },
      redirect:'/enterprise/enterprise_index',
      component:Layout,
      children:[
        {
          path:'enterprise_index',
          meta: {
            label:'工作台'
          },
          component: () => import('@/views/enterprise/enterprise_index'),
        },
        {
          path:'my_enterprise',
          meta: {
            label:'我的企业'
          },
          component: () => import('@/views/enterprise/my_enterprise'),
        },
        {
          path:'enterprise_info_view',
          meta: {
            label:'企业信息更新'
          },
          component: () => import('@/views/enterprise/enterprise_info_view')
        },
        {
          path:'enterprise_info_detail',
          meta:{
            label:'企业信息预览'
          },
          component: () => import('@/views/enterprise/enterprise_info_detail')
        },
        {
          path:'enterprise_calendar',
          meta: {
            label:'企业面试日历'
          },
          component: () => import('@/views/job/apply/enterprise_calendar'),
        },
        {
          path:'interview_manage',
          meta: {
            label:'面试管理'
          },
          component: () => import('@/views/job/apply/interview_manage'),
        },
        {
          path:'enterprise_interview_list',
          meta: {
            label:'已发出的邀约'
          },
          component: () => import('@/views/job/apply/enterprise_interview_list'),
        },
        {
          path:'enterprise_detail',
          component: () => import('@/views/enterprise/enterprise_detail'),
        },
        {
          path:'enterprise_comment_honor',
          meta: {
            label:'我的点评'
          },
          component: () => import('@/views/enterprise/comment_honor'),
        },
        {
          path:'enterprise_comment_all',
          meta: {
            label:'全部评论'
          },
          component: () => import('@/views/enterprise/comment_all'),
        }
      ]
    },
    {
      path:'/exam',
      name:'Exam',
      meta: {
        label:'人才测评'
      },
      component:Layout,
      children:[
        {
          path:'user_exam_manager',
          meta: {
            label:'测评管理'
          },
          component: () => import('@/views/exam/user_exam_manager'),
        },
        {
          path:'exam_list',
          meta: {
            label:'试题列表'
          },
          component: () => import('@/views/exam/exam_list'),
        },
        {
          path:'exam_detail',
          meta: {
            label:'测评内容'
          },
          component: () => import('@/views/exam/exam_detail'),
        },{
          path:'exam_manager',
          meta: {
            label:'测评邀请'
          },
          component: () => import('@/views/exam/exam_manager'),
        },{
          path:'exam_invite_list/:state',
          meta: {
            label:'发出的测评'
          },
          component: () => import('@/views/exam/exam_invite_list'),
        },{
          path:'exam_advice_list/:state',
          meta: {
            label:'收到的测评'
          },
          component: () => import('@/views/exam/exam_advice_list'),
        },{
          path:'my_exam_list',
          meta: {
            label:'我收到的测评'
          },
          component: () => import('@/views/exam/my_exam_list'),
        }
      ]
    },
    {
      path:'/ability',
      name:'Ability',
      meta: {
        label:'平台能力'
      },
      component:Layout,
      children:[
        {
          path:'enterprise_manage',
          meta:{
            label:'企业管理'
          },
          component: () => import('@/views/ability/enterprise_manage')
        },
        {
          path: 'ability_index',
          meta: {
            label:'套餐管理'
          },
          component: () => import('@/views/ability/ability_index')
        },
        {
          path: 'ability_list',
          meta: {
            label:'套餐列表'
          },
          component: () => import('@/views/ability/ability_list')
        },
        {
          path: 'ability_buy_history',
          meta: {
            label:'消费记录'
          },
          component: () => import('@/views/ability/ability_buy_history')
        },
        {
          path:'submit_order',
          meta: {
            label:'提价订单'
          },
          component: () => import('@/views/ability/submit_order')
        }
      ]
    },
    {
      path:'/article',
      name:'Article',
      meta: {
        label:'海豚优选'
      },
      component:Layout,
      children:[
        {
          path: 'hiturn_good_enterprise',
          meta: {
            label:'优质企业发布'
          },
          component: () => import('@/views/article/article_list')
        },
        {
          path: 'hiturn_enterprise',
          meta: {
            label:'企业服务'
          },
          component: () => import('@/views/article/article_list')
        },
        {
          path: 'hiturn_personal',
          meta: {
            label:'个人服务'
          },
          component: () => import('@/views/article/article_detail')
        },
        {
          path:'article_detail',
          meta: {
            label:'内容预览'
          },
          component: () => import('@/views/article/article_detail')
        }
      ]
    },
    {
      path:'/data',
      name:'Data',
      meta: {
        label:'大数据'
      },
      component:Layout,
      children:[
        {
          path: 'center',
          meta: {
            label:'数据中心'
          },

          component: () => {
            if (store.getters.userType=='enterprise') {
              return import('@/views/data/center')
            }else{
              return import('@/views/data/center_personal')
            }
          },
          // component: () => import('@/views/data/center')
        }
      ]
    },
    {
      path:'/tools',
      name:'Tool',
      meta: {
        label:'PC工具'
      },
      component:Layout,
      children:[
        {
          path: 'test_review',
          meta: {
            label:'Hiturn职业测评系统'
          },
          component: () => import('@/views/tools/test_review')
        },
        {
          path: 'hr',
          meta: {
            label:'eHR工具'
          },
          component: () => import('@/views/tools/hr')
        },
        {
          path: 'ehr',
          meta: {
            label:'eHR工具'
          },
          component: () => import('@/views/tools/ehr')
        },{
          path:'exam_content',
          meta: {
            label:'Hiturn职业测评内容'
          },
          component: () => import('@/views/tools/exam_content')
        }
      ]
    },
    {
      path:'/ai',
      name:'AI',
      meta: {
        label:'AI'
      },
      component:Layout,
      children:[
        {
          path: 'interview',
          meta: {
            label:'AI面试'
          },
          component: () => import('@/views/ai/interview')
        }
      ]
    },
    {
      path:'/fair',
      name:'fair',
      redirect:'/fair/index',
      meta: {
        label:'fair'
      },
      component:FairLayout,
      children:[
        {
          path: 'default',
          meta: {
            label:'在线招聘'
          },
          component: () => import('@/views/fair/default')
        },
        {
          path: 'aboutUs',
          meta: {
            label:'关于我们'
          },
          component: () => import('@/views/fair/aboutUs')
        },
        {
          path: 'index',
          meta: {
            label:'在线招聘首页'
          },
          component: () => import('@/views/fair/index')
        },
        {
          path: 'site',
          meta: {
            label:'在线招聘现场'
          },
          component: () => import('@/views/fair/site')
        },
        {
          path: 'fairall',
          meta: {
            label:'全部招聘会'
          },
          component: () => import('@/views/fair/fairall')
        },
        {
          path: 'newsall',
          meta: {
            label:'全部公告'
          },
          component: () => import('@/views/fair/newsall')
        },
        {
          path: 'newsdetail',
          meta: {
            label:'公告详情'
          },
          component: () => import('@/views/fair/news_detail')
        },
        {
          path: 'community_static',
          meta: {
            label:'知家社区'
          },
          component: () => import('@/views/fair/community_static')
        },
        {
          path: 'exam_static',
          meta: {
            label:'职业测评'
          },
          component: () => import('@/views/fair/exam_static')
        },
        {
          path: 'guidance_static',
          meta: {
            label:'职业指导'
          },
          component: () => import('@/views/fair/guidance_static')
        }
      ]
    },
    {
      path:'/msg',
      name:'msg',
      redirect:'/msg/index',
      meta: {
        label:'msg'
      },
      component:Layout,
      children:[
        {
          path: 'index',
          meta: {
            label:'全部消息'
          },
          component: () => import('@/views/msg/index')
        }
      ]
    },
    {
      path:'/',
      name: 'studyAndGrow',
      component: Layout,
      meta:{
        label:''
      },
      children:[
        {
          path:'studyAndGrow',
          meta:{
            label:'学习成长'
          },
          component: () => import('@/views/studyAndGrow'),
        }
      ]
    },
    {
      path:'/map',
      component: MapLayout,
      name:'map',
      meta:{
        label:'人才地图'
      },
      redirect:'/map/hiturn_map',
      children:[{
        path: 'hiturn_map',
        meta: {
          label: '人才地图'
        },
        component: () => import('@/views/cv/hiturn_map')
      }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js